import { useState, useRef } from "react";
import DangerButton from "../../../Components/DangerButton";
import Modal from "../../../Components/Modal";
import SecondaryButton from "../../../Components/SecondaryButton";
import InputLabel from "../../../Components/InputLabel";
import InputError from "../../../Components/InputError";
import TextInput from "../../../Components/TextInput";
import axios from "../../../axios";

export default function DeleteUserForm({ className = "" }) {
  const [showModal, setShowModal] = useState(false);
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [processing, setProcessing] = useState(false);
  const passwordInput = useRef();

  const confirmUserDeletion = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setPassword("");
    setErrors({});
  };

  const deleteUser = async (e) => {
    e.preventDefault();
    setProcessing(true);
    setErrors({});

    try {
      await axios.delete("/api/profile", {
        data: { password },
      });

      // Redirect to home or login page after account deletion
      window.location.href = "/";
    } catch (error) {
      if (error.response && error.response.data.errors) {
        setErrors(error.response.data.errors); // Handle validation errors
      } else {
        console.error("Error deleting user:", error);
      }
    } finally {
      setProcessing(false);
    }
  };

  return (
    <section className={`space-y-6 ${className}`}>
      <header>
        <h2 className="text-lg font-medium text-gray-900">Διαγραφή λογαριασμού</h2>
        <p className="mt-1 text-sm text-gray-600">
        Μόλις διαγραφεί ο λογαριασμός σας, όλοι οι πόροι και τα δεδομένα του θα διαγραφούν οριστικά. Εισαγάγετε τον κωδικό πρόσβασής σας για να επιβεβαιώσετε ότι θέλετε να διαγράψετε οριστικά τον λογαριασμό σας.
        </p>
      </header>

      <DangerButton onClick={confirmUserDeletion}>Διαγραφή λογαριασμού</DangerButton>

      <Modal show={showModal} onClose={closeModal}>
        <form onSubmit={deleteUser} className="p-6">
          <h2 className="text-lg font-medium text-gray-900">
          Είστε βέβαιοι ότι θέλετε να διαγράψετε τον λογαριασμό σας;
          </h2>

          <p className="mt-1 text-sm text-gray-600">
          Αυτή η ενέργεια είναι μόνιμη. Εισαγάγετε τον κωδικό πρόσβασής σας για επιβεβαίωση.
          </p>

          <div className="mt-4">
            <InputLabel htmlFor="password" value="Κωδικός πρόσβασης" />
            <TextInput
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              ref={passwordInput}
              className="mt-1 block w-full"
              placeholder="Password"
              required
            />
            <InputError message={errors.password} className="mt-2" />
          </div>

          <div className="mt-6 flex justify-end">
            <SecondaryButton onClick={closeModal}>Cancel</SecondaryButton>
            <DangerButton className="ml-3" disabled={processing}>
              {processing ? "Διαγραφή..." : "Διαγραφή λογαριασμού"}
            </DangerButton>
          </div>
        </form>
      </Modal>
    </section>
  );
}
